// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useMemo} from 'react';
import {Settings_context} from '../settings_ctx';
import {App_context} from 'hola_app_context';
import {Editor} from '../../../shared/editor/editor';
import {use_translation_v} from '../lib/trans_v';
import {use_install_info} from '../ui/use_install_info';
import {guess_browser} from 'zuser_agent';
import cn from 'classnames';
import {Svg_img} from '../ui/svg_img';
import {Link} from '../ui/link';
import {Install_btn} from '../ui/install_btn';
// @ts-ignore
import {hola_apps} from '../install_constants.js';
import styles from './vpn_country_hero.module.less';
import {use_countries} from '../ui/forms/use_countries';
import zcountry from 'zcountry';

const options = [
    'locations.hero.options.one',
    'locations.hero.options.two',
    'locations.hero.options.three',
];

const stores = {
    ios: <Svg_img id={'hola2023/store_ios.svg'} />,
    huawei: <Svg_img id={'hola2023/store_huawei.svg'}/>,
    // XXX dmitriikup: URG request from noav to remove all Samsung
    // mentions from www
    // samsung: <Svg_img id={'hola2023/store_samsung.svg'}/>
};

interface i_hero_props {
    country: string;
    region?: string;
}

export const Vpn_country_hero = (props: i_hero_props)=>{
    const {country} = props;
    const {theme} = useContext(Settings_context);
    const {countries} = use_countries('fsvg_4x3', cn(styles.flag_wrap,
        theme.xs, theme.P), styles.flag_icon, null, null, true);
    const curr_country = useMemo(()=>countries.find(el=>
        el.title.toUpperCase()==(country||'')?.toUpperCase()), []);
    // @ts-ignore
    const {host} = useContext(App_context);
    const {t} = use_translation_v();
    const {app} = use_install_info({host});
    const adj = zcountry.adj_list[curr_country?.value] ||
        zcountry.extra_adj_list[curr_country?.value] || null;
    const is_ext = app=='ext';
    const cta_text = is_ext ? t('locations.hero.cta_ext')
      : t('locations.hero.cta_app');
    const b = guess_browser();
    // XXX dmitriikup: URG request from noav to remove all Samsung
    // mentions from www
    // const mobile_os = b.ios ? 'ios' : b.huawei ? 'huawei' : b.android ?
    //   'android' :'samsung';
    const mobile_os = b.ios ? 'ios' : b.huawei ? 'huawei' : 'android';
    const install_btn_cls = cn('hola_btn hola_btn--lg hola_btn--round',
      'hola_btn--txt_colored hola_btn--no_jump',
      mobile_os!=='android' && styles.desktop);
    const link = hola_apps.mobile.find(a=>a.name===mobile_os)?.href||'';
    return <div className={styles.gradient_premium}>
      <div className={cn(styles.top, styles.mobile_top)}>
        <div className={styles.title}>
          <div className={styles.global_tablet}>
            {curr_country && curr_country?.rendered_item}
          </div>
          <h1 className={cn(theme.color_n700)}>
            {is_ext ? t('locations.hero.title_ext', {adj: adj?.name})
              : t('locations.hero.title_app', {adj: adj?.name})}</h1>
          <div className={styles.options}>
            {options.map((opt, i)=><div key={i}
              className={styles.option_wrapper}>
              <Svg_img id={'hola2023/icons/18/check.svg'}
                cls={styles.check_icon} w={18} h={18}/>
              <p className={cn(theme.p3, theme.reg, theme.color_n700)}>
                {t(opt, {adj: adj?.name})}</p>
          </div>)}
          </div>
          <Link href={link} className={styles.mobile}>
            {stores[mobile_os]}
          </Link>
          <Install_btn keep_btn_text text={cta_text}
            className={cn(install_btn_cls, styles.cta)} no_redirect/>
        </div>
        <div className={styles.global}>
          <Svg_img id={'global.svg'} />
          {curr_country && curr_country?.rendered_item}
        </div>
      </div>
    </div>;
};

interface i_vpn_country_hero_props {
    value: unknown;
    on_change: (new_val: unknown)=>void;
}

export const Vpn_country_hero_editor = (
{value, on_change}: i_vpn_country_hero_props)=>{
    return <Editor value={value} on_change={on_change} editors={[]}/>;
};
